import { BrowserRouter } from "react-router-dom";
import { Header } from "./Layouts/Header";
import { Footer } from "./Layouts/Footer";
import { Router } from "./Router/Router";


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <div style={{marginTop: '3.5rem'}}></div>
        <Router />

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
